import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=76dc13d2&scoped=true&"
import script from "./SkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./SkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&id=76dc13d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dc13d2",
  null
  
)

export default component.exports